export function setAgreements(state, payload) {
  state.agreement = payload;
}
